import formatNumber from '@helpers/format_number';

export const createEmailMap = (response) => {
  const emailMap = { default: 'unknown' };

  if (!response) {
    return emailMap;
  }

  response.included.forEach((includedItem) => {
    if (includedItem.type === 'users') {
      emailMap[includedItem.id] = includedItem.attributes.email;
    }
  });

  return emailMap;
};

export const createCheckinCheckoutEvent = (reservations, reservation, baseEvent) => {
  const newEvent = Object.assign({}, baseEvent);
  const { created_at, note, status } = reservation.attributes;
  const userData = reservation.relationships.user.data;
  const userId = userData && userData.id ? userData.id : 'default';
  const action = status.replace("_", " ");

  newEvent.action = action.charAt(0).toUpperCase() + action.slice(1);
  newEvent.note = note;
  newEvent.updatedAt = created_at;
  newEvent.updatedByEmail = createEmailMap(reservations)[userId];
  newEvent.updatedById = userId;

  return newEvent;
};

export const formatVersions = (versionsResponse) => {
  const versions = versionsResponse ? versionsResponse.data : [];
  const emailMap = createEmailMap(versionsResponse);

  versions.sort((a, b) => new Date(a.attributes.created_at) - new Date(b.attributes.created_at));

  const attachmentVersions = versions.map((version, i) => {
    const userData = version.relationships.user.data;
    const userId = userData && userData.id ? userData.id : 'default';

    return {
      action: i === 0 ? t('Created') : t('Updated'),
      currentVersion: i === versions.length - 1,
      downloadUrl: version.attributes.version_details.url,
      filename: version.attributes.version_details.filename,
      height: version.attributes.version_details.height,
      key: version.id,
      mimeType: version.attributes.version_details.metadata.mime_type || 'image/png',
      note: null,
      size: formatNumber(version.attributes.version_details.size),
      thumbnailUrl: version.attributes.version_details.small_thumbnail,
      updatedAt: version.attributes.created_at,
      updatedByEmail: emailMap[userId],
      updatedById: userId,
      versionKey: version.id,
      width: version.attributes.version_details.width,
    };
  });

  return attachmentVersions;
};

export const joinVersionEvents = (versions, reservations) => {
  const versionEvents = [];
  const versionEventDates = [];

  if (!reservations) {
    return versionEvents;
  }

  versions.forEach((version) => versionEventDates.push(version.updatedAt));
  reservations.data.forEach((reservation) => versionEventDates.push(reservation.attributes.created_at));
  versionEventDates.sort((a, b) => new Date(a) - new Date(b));

  versionEventDates.forEach((date) => {
    versions.forEach((version) => {
      if (date === version.updatedAt) {
        versionEvents.push(version);
      }
    });

    reservations.data.forEach((reservation) => {
      if (date === reservation.attributes.created_at) {
        const baseEvent = versionEvents[versionEvents.length - 1];
        const checkinCheckoutEvent = createCheckinCheckoutEvent(reservations, reservation, baseEvent);

        versionEvents.push(checkinCheckoutEvent);
      }
    });
  });

  return versionEvents.reverse();
};

export const handleCheckedStatus = (joinedEvents) => {
  const checkedStatus = { checkinCheckoutEvent: false };

  joinedEvents.forEach((event, i) => {
    if (event.action.toLowerCase().indexOf('check') > -1 && !checkedStatus.checkinCheckoutEvent) {
      checkedStatus.checkinCheckoutEvent = true;
      checkedStatus.checkedinStatus = event.action === 'Checked in';
      checkedStatus.email = event.updatedByEmail;
      checkedStatus.userKey = event.updatedById;
      checkedStatus.updatedAt = event.updatedAt;
    }

    // no checkin-checkout events indicates the version is checkedin
    if (!checkedStatus.checkinCheckoutEvent && i === joinedEvents.length - 1) {
      checkedStatus.checkedinStatus = true;
    }
  });

  return checkedStatus;
};
